import { render, staticRenderFns } from "./AddNoteModal.vue?vue&type=template&id=5ed0c4a1"
import script from "./AddNoteModal.vue?vue&type=script&lang=ts"
export * from "./AddNoteModal.vue?vue&type=script&lang=ts"
import style0 from "./AddNoteModal.vue?vue&type=style&index=0&id=5ed0c4a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports